// import { AuthenticationActions } from "./authentication/AuthenticationSlice";
import { AuthUserInfoActions } from './authUserInfo/AuthUserInfoSlice';
import { CategoriesActions } from './categories/CategoriesSlice';
import { InvitedPostsActions } from './invitedPosts/InvitedPostsSlice';
import { InvitePeopleActions } from './invitePeople/invitePeopleSlice';
import { LogoutActions } from './logout/LogoutSlice';
import { NotificationsPostsActions } from './notifications/NotificationsSlice';
import { PendingPostsActions } from './pendingPosts/PendingPostsSlice';
import { PostActions } from './post/PostSlice';
import { PublishedPostsActions } from './publishedPosts/PublishedPostsSlice';
import { UnsubscribedUsersActions } from './unsubscribedUsers/UnsubscribedUsersSlice';

const actions = {
    ...InvitePeopleActions,
    ...InvitedPostsActions,
    ...PublishedPostsActions,
    ...PendingPostsActions,
    ...NotificationsPostsActions,
    ...CategoriesActions,
    ...PostActions,
    ...AuthUserInfoActions,
    ...UnsubscribedUsersActions,
    ...LogoutActions,
};

export default actions;
